import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import React from 'react';

import appStore from '../assets/images/appStore.png';
import config from '../../site-config';
import playStore from '../assets/images/playStore.png';

const FoundBlock = ({ code }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      {code && (
        <>
          <div className="text-center">
            <h1>
              {code}
            </h1>
          </div>
          <p className="subtitle my-4 mx-2 text-center">
            {t('youFoundATaggi')}
          </p>
        </>
      )}
      <div className="my-4 text-center">
        <p className="text-lg lg:text-xl">
          <strong>
            1.
            {' '}
            {t('fid_downloadTaggi')}
          </strong>
          {' '}
        </p>
        <p className="mb-8">{t('downloadExplain')}</p>
        <p className="text-lg lg:text-xl">
          <strong>
            2.
            {' '}
            {t('introduceCode')}
          </strong>
          {' '}
        </p>
        <p className="mb-8">{t('introduceCodeExplain')}</p>
        <p className="text-lg lg:text-xl">
          <strong>
            3.
            {' '}
            {t('fid_contact')}
          </strong>
        </p>
        <p className="mb-8">{t('fid_contactExplain')}</p>
        <Link className="text-lg" to="/#faq">
          {t('fid_contactWarn')}
        </Link>
      </div>
      <p className="subtitle my-4 mx-2 text-center">
        {t('fid_youCanFound')}
      </p>
      <div
        className="
          flex
          flex-col
          items-center
          justify-center
          mt-16
          sm:flex-row
        "
      >
        {config.playStoreLink && (
          <div className="flex flex-col relative">
            <a
              className={`
                p-4
                ${config.playStoreLink === 'soon' ? 'opacity-50' : ''}
              `}
              href={config.playStoreLink !== 'soon' && config.playStoreLink}
            >
              <img
                alt="play store"
                src={playStore}
              />
            </a>
          </div>
        )}
        {config.appStoreLink && (
          <div className="flex flex-col relative">
            <a
              className={`
                p-4
                ${config.appStoreLink === 'soon' ? 'opacity-50' : ''}
              `}
              href={config.appStoreLink !== 'soon' && config.appStoreLink}
            >
              <img
                alt="app store"
                src={appStore}
              />
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default FoundBlock;
